/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_No_OpeningsInputs */

const en_booking_no_openings = /** @type {(inputs: Booking_No_OpeningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No openings on this day. Try another date.`)
};

const es_booking_no_openings = /** @type {(inputs: Booking_No_OpeningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay horarios este día. Prueba otra fecha.`)
};

const de_booking_no_openings = /** @type {(inputs: Booking_No_OpeningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An diesem Tag sind keine Termine frei. Bitte wählen Sie ein anderes Datum.`)
};

const zh_booking_no_openings = /** @type {(inputs: Booking_No_OpeningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这一天没有可预约的时间。请换一个日期。`)
};

const ar_booking_no_openings = /** @type {(inputs: Booking_No_OpeningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد مواعيد في هذا اليوم. جرّب تاريخاً آخر.`)
};

const fr_booking_no_openings = /** @type {(inputs: Booking_No_OpeningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun créneau disponible ce jour-là. Essayez une autre date.`)
};

const vi_booking_no_openings = /** @type {(inputs: Booking_No_OpeningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày này không còn chỗ. Hãy thử ngày khác.`)
};

const sw_booking_no_openings = /** @type {(inputs: Booking_No_OpeningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna nafasi siku hii. Jaribu tarehe nyingine.`)
};

const th_booking_no_openings = /** @type {(inputs: Booking_No_OpeningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีเวลาว่างในวันที่เลือก ลองเลือกวันอื่น`)
};

const bs_booking_no_openings = /** @type {(inputs: Booking_No_OpeningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nema slobodnih termina ovog dana. Pokušajte drugi datum.`)
};

const ja_booking_no_openings = /** @type {(inputs: Booking_No_OpeningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この日は空き時間がありません。別の日付を選択してください。`)
};

const ko_booking_no_openings = /** @type {(inputs: Booking_No_OpeningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 날짜에는 예약 가능한 시간이 없습니다. 다른 날짜를 선택해 주세요.`)
};

const pt_booking_no_openings = /** @type {(inputs: Booking_No_OpeningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não há horários livres neste dia. Escolha outra data.`)
};

const it_booking_no_openings = /** @type {(inputs: Booking_No_OpeningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun orario disponibile in questo giorno. Prova un’altra data.`)
};

const sv_booking_no_openings = /** @type {(inputs: Booking_No_OpeningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga lediga tider denna dag. Välj ett annat datum.`)
};

const nl_booking_no_openings = /** @type {(inputs: Booking_No_OpeningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen vrije tijden op deze dag. Kies een andere datum.`)
};

const da_booking_no_openings = /** @type {(inputs: Booking_No_OpeningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen ledige tider denne dag. Vælg en anden dato.`)
};

const nb_booking_no_openings = /** @type {(inputs: Booking_No_OpeningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen ledige tider denne dagen. Prøv en annen dato.`)
};

const fi_booking_no_openings = /** @type {(inputs: Booking_No_OpeningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tälle päivälle ei ole vapaita aikoja. Valitse toinen päivä.`)
};

const pl_booking_no_openings = /** @type {(inputs: Booking_No_OpeningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak wolnych terminów w tym dniu. Wybierz inną datę.`)
};

const ru_booking_no_openings = /** @type {(inputs: Booking_No_OpeningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`На этот день нет свободного времени. Выберите другую дату.`)
};

const tr_booking_no_openings = /** @type {(inputs: Booking_No_OpeningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu gün için boş saat yok. Başka bir tarih deneyin.`)
};

const hi_booking_no_openings = /** @type {(inputs: Booking_No_OpeningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस दिन कोई समय खाली नहीं है। कोई दूसरी तारीख चुनें।`)
};

const id_booking_no_openings = /** @type {(inputs: Booking_No_OpeningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada jadwal kosong pada hari ini. Pilih tanggal lain.`)
};

const ms_booking_no_openings = /** @type {(inputs: Booking_No_OpeningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada slot kosong pada hari ini. Pilih tarikh lain.`)
};

const cs_booking_no_openings = /** @type {(inputs: Booking_No_OpeningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V tento den nejsou volné termíny. Vyberte jiné datum.`)
};

const el_booking_no_openings = /** @type {(inputs: Booking_No_OpeningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δεν υπάρχουν διαθέσιμες ώρες αυτή την ημέρα. Επιλέξτε άλλη ημερομηνία.`)
};

const he_booking_no_openings = /** @type {(inputs: Booking_No_OpeningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אין שעות פנויות ביום הזה. נסו תאריך אחר.`)
};

const af_booking_no_openings = /** @type {(inputs: Booking_No_OpeningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen tye beskikbaar op hierdie dag nie. Probeer 'n ander datum.`)
};

const hu_booking_no_openings = /** @type {(inputs: Booking_No_OpeningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ezen a napon nincs szabad időpont. Válassz másik napot.`)
};

/**
* | output |
* | --- |
* | "No openings on this day. Try another date." |
*
* @param {Booking_No_OpeningsInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_no_openings = /** @type {((inputs?: Booking_No_OpeningsInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_No_OpeningsInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_no_openings(inputs)
	if (locale === "de") return de_booking_no_openings(inputs)
	if (locale === "zh") return zh_booking_no_openings(inputs)
	if (locale === "ar") return ar_booking_no_openings(inputs)
	if (locale === "fr") return fr_booking_no_openings(inputs)
	if (locale === "vi") return vi_booking_no_openings(inputs)
	if (locale === "sw") return sw_booking_no_openings(inputs)
	if (locale === "th") return th_booking_no_openings(inputs)
	if (locale === "bs") return bs_booking_no_openings(inputs)
	if (locale === "ja") return ja_booking_no_openings(inputs)
	if (locale === "ko") return ko_booking_no_openings(inputs)
	if (locale === "pt") return pt_booking_no_openings(inputs)
	if (locale === "it") return it_booking_no_openings(inputs)
	if (locale === "sv") return sv_booking_no_openings(inputs)
	if (locale === "nl") return nl_booking_no_openings(inputs)
	if (locale === "da") return da_booking_no_openings(inputs)
	if (locale === "nb") return nb_booking_no_openings(inputs)
	if (locale === "fi") return fi_booking_no_openings(inputs)
	if (locale === "pl") return pl_booking_no_openings(inputs)
	if (locale === "ru") return ru_booking_no_openings(inputs)
	if (locale === "tr") return tr_booking_no_openings(inputs)
	if (locale === "hi") return hi_booking_no_openings(inputs)
	if (locale === "id") return id_booking_no_openings(inputs)
	if (locale === "ms") return ms_booking_no_openings(inputs)
	if (locale === "cs") return cs_booking_no_openings(inputs)
	if (locale === "el") return el_booking_no_openings(inputs)
	if (locale === "he") return he_booking_no_openings(inputs)
	if (locale === "af") return af_booking_no_openings(inputs)
	if (locale === "hu") return hu_booking_no_openings(inputs)
	return en_booking_no_openings(inputs)
});